import React from "react";

function Footer() {
  return (
    // Menggunakan padding vertikal kecil (py-6) agar ukurannya tidak terlalu besar
    <footer className="w-full bg-white border-t-2 border-slate-900 font-sans mt-auto">
      <div className="mx-auto max-w-7xl px-6 py-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          {/* Sisi Kiri: Branding Minimalis */}
          <div className="flex items-center gap-2">
            <span className="text-base font-black tracking-tight text-slate-900">
              Gunjo<span className="text-gsf-bronze">.dev</span>
            </span>
            <span className="text-slate-300 select-none hidden sm:inline">
              |
            </span>
            <p className="text-xs text-slate-500 font-medium hidden md:inline">
              Building scalable systems and AI solutions.
            </p>
          </div>

          {/* Sisi Kanan: Hak Cipta & Navigasi Super Simpel */}
          <div className="flex flex-col sm:items-end gap-1 text-[11px] font-bold uppercase tracking-wider text-slate-500">
            <div>© 2026 Gugun Jofandi. All rights reserved.</div>
            <div className="flex items-center gap-1.5 sm:justify-end font-mono text-[10px] text-slate-400 lowercase">
              <span>crafted with ☕</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
